// @flow

import { connect } from 'react-redux';

import {
  DocsStep,
  type Zap,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';

import type { State } from 'app/common/types';

type Doc = {
  href: string,
  title: string,
};

type DocsContainerProps = {
  title: string,
  docs?: Doc[],
  body: ComponentType<*> | string,
  size: 'small' | 'medium' | 'large',
  zap?: Zap,
};

type App = {
  name: string,
  id: string,
  slug: string,
};

type DocsStepProps = {
  title: string,
  children: ComponentType<*> | string,
  docs?: Doc[],
  apps?: App[],
  size: 'small' | 'medium' | 'large',
};

const mapStateToProps = (
  state: State,
  props: DocsContainerProps
): DocsStepProps => {
  const { title, body, docs, size } = props;
  return {
    title,
    children: body,
    docs,
    size,
  };
};

const DocsContainer = connect(mapStateToProps)(DocsStep);

export default DocsContainer;
